var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnderDev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 734 654",
    width: 734,
    height: 654,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 268.1,
    y1: 536.1,
    x2: 268.1,
    y2: 651.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 29.5,
    y1: 655,
    x2: 545.2,
    y2: -54.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50e0d5",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 179.4,
    y1: 57.9,
    x2: 171.6,
    y2: 44.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b2987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 278.3,
    y1: 58.9,
    x2: 269.1,
    y2: 43.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b2987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: 179.4,
    y1: 123.7,
    x2: 171.6,
    y2: 110.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b2987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: 278.3,
    y1: 124.7,
    x2: 269.1,
    y2: 109.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b2987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 179.4,
    y1: 189.5,
    x2: 171.6,
    y2: 176.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b2987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 278.3,
    y1: 190.4,
    x2: 269.1,
    y2: 174.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b2987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x1: 179.4,
    y1: 255.2,
    x2: 171.6,
    y2: 242.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b2987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 278.3,
    y1: 256.2,
    x2: 269.1,
    y2: 240.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b2987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x1: 179.4,
    y1: 321,
    x2: 171.6,
    y2: 307.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b2987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g12",
    x1: 278.3,
    y1: 322,
    x2: 269.1,
    y2: 306.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b2987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g13",
    x1: 179.4,
    y1: 386.8,
    x2: 171.6,
    y2: 373.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b2987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g14",
    x1: 278.3,
    y1: 387.7,
    x2: 269.1,
    y2: 372.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b2987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x1: 179.4,
    y1: 452.5,
    x2: 171.6,
    y2: 439.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b2987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x1: 278.3,
    y1: 453.5,
    x2: 269.1,
    y2: 438,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b2987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g17",
    x1: 179.4,
    y1: 518.3,
    x2: 171.6,
    y2: 505.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b2987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g18",
    x1: 278.3,
    y1: 519.3,
    x2: 269.1,
    y2: 503.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f5fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b2987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g19",
    x1: 674.2,
    y1: 546.7,
    x2: 674.2,
    y2: 582.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g20",
    x1: 632,
    y1: 470.2,
    x2: 632,
    y2: 487.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bd8a2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91661a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g21",
    x1: 617.7,
    y1: 559.2,
    x2: 578.8,
    y2: 559.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g22",
    x1: 678.9,
    y1: 456.9,
    x2: 714.1,
    y2: 517.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{opacity:.1;mix-blend-mode:multiply;fill:url(#g1)}.b{fill:url(#g2)}.c{fill:#8f5fe3}.d{fill:url(#g3)}.e{fill:url(#g4)}.f{fill:url(#g5)}.g{fill:url(#g6)}.h{fill:url(#g7)}.i{fill:url(#g8)}.j{fill:url(#g9)}.k{fill:url(#g10)}.l{fill:url(#g11)}.m{fill:url(#g12)}.n{fill:url(#g13)}.o{fill:url(#g14)}.p{fill:url(#g15)}.q{fill:url(#g16)}.r{fill:url(#g17)}.s{fill:url(#g18)}.t{fill:#6331b5}.u{fill:#4f4f60}.v{fill:#50e0d5}.w{opacity:.1;mix-blend-mode:multiply;fill:url(#g19)}.x{fill:url(#g20)}.y{fill:#3a79ab}.z{fill:#f2823c}.A{fill:#ffd180}.B{fill:#316791}.C{fill:#b8d0e3}.D{fill:#f2b13c}.E{fill:#4da1e3}.F{opacity:.3;mix-blend-mode:screen;fill:url(#g21)}.G{opacity:.1;mix-blend-mode:multiply;fill:url(#g22)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m168.2 606.2h0.3v47.9h14.1v-47.9h90.7v47.9h14.1v-47.9h0.3c3.9 0 7.1-3.2 7.1-7.1 0-3.9-3.2-7-7.1-7h-0.3v-34.6c0-3.9-3.2-7-7.1-7-3.8 0-7 3.1-7 7v34.6h-90.7v-34.6c0-3.9-3.2-7-7-7-3.9 0-7.1 3.1-7.1 7v34.6h-0.3c-3.9 0-7.1 3.1-7.1 7 0 3.9 3.2 7.1 7.1 7.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m0.7 538.3c0 0 0-200.2 0-223.7 0-51.1 56.8-57.3 69.9-78.1 13.1-20.8 16.4-94.1 16.4-124.8 0-30.8 36.8-32.6 36.8 2.7 0 49.7 1.4 80.9 14.5 79.3 13.1-1.6 7.9-131.8 37.3-131.8 29.3 0 36.5 138.5 44.6 157.8 20.8 49.7 85.7 38.4 85.7 95.8 0 25.3-0.5 114.2-0.5 138.7 0 24.6 29.5 24.4 32.8 0 3.2-24.4 27.6-45.4 56.5-35.2 47.3 16.8 32.1 62.6 57 77.5 42.1 25.1 112.5 5.7 122.3 41.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m294.8 47.7v2.9c0 3.1-2.5 5.6-5.6 5.6h-122.5c-3.1 0-5.6-2.5-5.6-5.6v-2.9c0-3.1 2.5-5.5 5.6-5.5h122.5c3.1 0 5.6 2.4 5.6 5.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m182.6 42.2l10.5 14h-10.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m294.3 51.5l-6.9-9.3v14h0.3c3.1 0 5.7-2 6.6-4.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m294.8 113.5v2.9c0 3.1-2.5 5.6-5.6 5.6h-122.5c-3.1 0-5.6-2.5-5.6-5.6v-2.9c0-3.1 2.5-5.6 5.6-5.6h122.5c3.1 0 5.6 2.5 5.6 5.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m182.6 107.9l10.5 14.1h-10.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m294.3 117.3l-6.9-9.4v14.1h0.3c3.1 0 5.7-2 6.6-4.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m294.8 179.3v2.9c0 3-2.5 5.5-5.6 5.5h-122.5c-3.1 0-5.6-2.5-5.6-5.5v-2.9c0-3.1 2.5-5.6 5.6-5.6h122.5c3.1 0 5.6 2.5 5.6 5.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m182.6 173.7l10.5 14h-10.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m294.3 183l-6.9-9.3v14h0.3c3.1 0 5.7-1.9 6.6-4.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m294.8 245v2.9c0 3.1-2.5 5.6-5.6 5.6h-122.5c-3.1 0-5.6-2.5-5.6-5.6v-2.9c0-3.1 2.5-5.5 5.6-5.5h122.5c3.1 0 5.6 2.4 5.6 5.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m182.6 239.5l10.5 14h-10.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m294.3 248.8l-6.9-9.3v14h0.3c3.1 0 5.7-2 6.6-4.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m294.8 310.8v2.9c0 3.1-2.5 5.6-5.6 5.6h-122.5c-3.1 0-5.6-2.5-5.6-5.6v-2.9c0-3.1 2.5-5.6 5.6-5.6h122.5c3.1 0 5.6 2.5 5.6 5.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m182.6 305.2l10.5 14.1h-10.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m294.3 314.6l-6.9-9.4v14.1h0.3c3.1 0 5.7-2 6.6-4.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m294.8 376.5v3c0 3-2.5 5.5-5.6 5.5h-122.5c-3.1 0-5.6-2.5-5.6-5.5v-3c0-3 2.5-5.5 5.6-5.5h122.5c3.1 0 5.6 2.5 5.6 5.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m182.6 371l10.5 14h-10.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m294.3 380.3l-6.9-9.3v14h0.3c3.1 0 5.7-1.9 6.6-4.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m294.8 442.3v2.9c0 3.1-2.5 5.6-5.6 5.6h-122.5c-3.1 0-5.6-2.5-5.6-5.6v-2.9c0-3.1 2.5-5.6 5.6-5.6h122.5c3.1 0 5.6 2.5 5.6 5.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m182.6 436.7l10.5 14.1h-10.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m294.3 446.1l-6.9-9.4v14.1h0.3c3.1 0 5.7-2 6.6-4.7z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m294.8 508.1v2.9c0 3.1-2.5 5.6-5.6 5.6h-122.5c-3.1 0-5.6-2.5-5.6-5.6v-2.9c0-3.1 2.5-5.6 5.6-5.6h122.5c3.1 0 5.6 2.5 5.6 5.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m182.6 502.5l10.5 14.1h-10.5z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m294.3 511.9l-6.9-9.4v14.1h0.3c3.1 0 5.7-2 6.6-4.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m177 558.2h-2.9c-3.1 0-5.6-2.5-5.6-5.6v-546.5c0-3.1 2.5-5.5 5.6-5.5h2.9c3.1 0 5.6 2.4 5.6 5.5v546.5c0 3.1-2.5 5.6-5.6 5.6z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m281.8 558.2h-2.9c-3.1 0-5.6-2.5-5.6-5.6v-546.5c0-3.1 2.5-5.5 5.6-5.5h2.9c3.1 0 5.6 2.4 5.6 5.5v546.5c0 3.1-2.5 5.6-5.6 5.6z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m352.1 152h-5.7v-24.8h10.6q1.8 0 3.2 0.7 1.5 0.7 2.6 1.9 1.1 1.2 1.7 2.7 0.6 1.5 0.6 3.1 0 2.1-1 4-1 2-2.8 3.2-1.7 1.2-4.1 1.2h-5.1zm0-19.8v6.8h4.7q0.7 0 1.2-0.4 0.6-0.4 0.9-1.2 0.4-0.7 0.4-1.9 0-1.1-0.4-1.9-0.4-0.7-1-1.1-0.6-0.3-1.3-0.3zm11.9 19.8l8.6-24.9h6.2l8.5 24.9h-5.8l-2-5.6h-7.7l-1.9 5.6zm8.7-9.5h5.9l-2.9-9.6zm8.1-22.5l-3.3 5.5-3.6-0.9 1.8-4.6zm18.5 32.2q-2.4 0-4.6-0.9-2.2-0.9-3.8-2.6-1.7-1.7-2.6-4.1-0.9-2.3-0.9-5.2 0-2.6 0.9-4.8 1-2.2 2.7-4 1.6-1.7 3.9-2.6 2.3-1 4.9-1 3.4 0 6 1.5 2.7 1.4 3.9 3.9l-4.2 3.3q-0.9-1.7-2.5-2.6-1.6-1-3.4-1-1.4 0-2.6 0.6-1.2 0.6-2 1.6-0.9 1-1.3 2.4-0.5 1.4-0.5 2.9 0 1.7 0.5 3 0.5 1.4 1.4 2.4 0.8 1 2 1.5 1.2 0.6 2.7 0.6 1.8 0 3.4-0.9 1.7-0.9 3-2.6v5.6q-3 3-6.9 3zm6.6-0.2v-8.8h-4.9v-4.2h9.6v13zm14.3 0h-5.7v-24.8h5.7zm21.9 0l-11.4-14.2v14.2h-5.7v-24.9h4.5l11.5 14.7v-14.7h5.8v24.9zm7.1 0l8.6-24.9h6.2l8.5 24.9h-5.9l-1.9-5.6h-7.7l-1.9 5.6zm8.7-9.5h5.9l-2.9-9.6zm-105.8 46.5h11.7v5h-17.5v-24.8h17.2v5h-11.4v4.8h9.8v4.7h-9.8zm40.5 5h-5.7v-14.8l-5.3 10.8h-3.2l-5.4-10.8v14.8h-5.7v-24.8h6.2l6.5 13 6.5-13h6.1zm-37 42h-9.3v-24.9h9.3q4.1 0 6.8 1.7 2.8 1.7 4.2 4.5 1.4 2.8 1.4 6.2 0 3.8-1.5 6.6-1.6 2.8-4.4 4.4-2.7 1.5-6.5 1.5zm6.6-12.5q0-2.1-0.8-3.8-0.8-1.7-2.2-2.6-1.5-0.9-3.6-0.9h-3.5v14.8h3.5q2.1 0 3.6-1 1.4-1 2.2-2.7 0.8-1.7 0.8-3.8zm14.9 7.5h11.8v5h-17.5v-24.9h17.2v5.1h-11.5v4.8h9.8v4.7h-9.8zm32.7-17.3l-2.5 4.7q-0.1-0.1-0.8-0.5-0.6-0.4-1.5-0.8-1-0.4-2.1-0.7-1.1-0.3-2.2-0.3-1.5 0-2.3 0.5-0.8 0.5-0.8 1.5 0 0.9 0.6 1.4 0.6 0.4 1.8 0.8 1.1 0.4 2.8 0.9 2.4 0.6 4.1 1.5 1.8 0.9 2.7 2.3 0.9 1.4 0.9 3.7 0 2.1-0.7 3.6-0.8 1.4-2.1 2.3-1.3 0.9-3 1.3-1.7 0.4-3.5 0.4-1.8 0-3.7-0.4-1.9-0.3-3.7-1-1.7-0.7-3.2-1.7l2.5-5q0.2 0.2 0.9 0.7 0.8 0.4 1.9 0.9 1.2 0.5 2.6 0.9 1.4 0.4 2.8 0.4 1.6 0 2.3-0.5 0.8-0.5 0.8-1.3 0-1-0.8-1.5-0.8-0.5-2.2-1-1.3-0.4-3-0.9-2.3-0.7-3.8-1.6-1.5-0.9-2.2-2.1-0.7-1.3-0.7-3.2 0-2.6 1.2-4.4 1.3-1.8 3.4-2.7 2.1-1 4.5-1 1.8 0 3.4 0.5 1.6 0.4 3 1 1.5 0.6 2.6 1.3zm9.8 17.3h11.8v5h-17.5v-24.8h17.1v5h-11.4v4.8h9.8v4.7h-9.8zm32.4 5l-11.4-14.2v14.2h-5.7v-24.8h4.5l11.5 14.6v-14.6h5.8v24.8zm6.9-24.8h6.1l5.9 18.1 5.7-18.1h6.1l-9 24.8h-5.7zm36 25.1q-2.8 0-5.1-1.1-2.2-1.1-3.9-2.8-1.6-1.9-2.4-4.1-0.9-2.3-0.9-4.7 0-2.5 0.9-4.7 0.9-2.3 2.6-4 1.7-1.8 3.9-2.8 2.3-1 5-1 2.8 0 5 1.1 2.3 1 3.9 2.8 1.6 1.9 2.5 4.1 0.9 2.3 0.9 4.6 0 2.5-0.9 4.7-0.9 2.3-2.6 4.1-1.7 1.7-4 2.8-2.2 1-4.9 1zm-6.5-12.6q0 1.4 0.5 2.8 0.4 1.3 1.2 2.4 0.8 1 2 1.6 1.3 0.7 2.8 0.7 1.7 0 2.9-0.7 1.2-0.6 2-1.7 0.8-1.1 1.2-2.4 0.5-1.4 0.5-2.8 0-1.4-0.5-2.8-0.4-1.3-1.2-2.3-0.9-1.1-2.1-1.7-1.2-0.6-2.8-0.6-1.6 0-2.8 0.6-1.2 0.7-2.1 1.7-0.8 1.1-1.2 2.5-0.4 1.3-0.4 2.7zm40 12.4h-17.8v-24.9h5.8v19.8h12zm-2.8-24.8h6.1l5.8 18.1 5.8-18.1h6l-9 24.8h-5.6zm31.8 24.9h-5.8v-24.9h5.8zm30.1 0h-5.8v-14.8l-5.3 10.8h-3.2l-5.3-10.8v14.8h-5.8v-24.8h6.3l6.4 13 6.5-13h6.2zm10.5-5.1h11.7v5.1h-17.5v-24.9h17.2v5.1h-11.4v4.8h9.8v4.7h-9.8zm32.3 5l-11.4-14.2v14.2h-5.7v-24.9h4.6l11.5 14.7v-14.7h5.7v24.9zm28.4-24.9v5.1h-7.6v19.8h-5.7v-19.8h-7.6v-5.1zm13.2 25.1q-2.8 0-5.1-1-2.2-1.1-3.9-2.9-1.6-1.8-2.4-4.1-0.9-2.2-0.9-4.7 0-2.4 0.9-4.7 0.9-2.2 2.6-4 1.7-1.8 3.9-2.8 2.3-1 5-1 2.8 0 5 1.1 2.3 1 3.9 2.9 1.6 1.8 2.5 4.1 0.9 2.2 0.9 4.5 0 2.5-0.9 4.8-0.9 2.2-2.6 4-1.7 1.7-4 2.8-2.2 1-4.9 1zm-6.5-12.6q0 1.4 0.4 2.8 0.5 1.3 1.3 2.4 0.8 1 2 1.7 1.3 0.6 2.8 0.6 1.7 0 2.9-0.6 1.2-0.7 2-1.8 0.8-1.1 1.2-2.4 0.4-1.4 0.4-2.8 0-1.4-0.4-2.7-0.4-1.4-1.2-2.4-0.9-1.1-2.1-1.7-1.2-0.6-2.8-0.6-1.6 0-2.8 0.6-1.2 0.7-2.1 1.8-0.8 1-1.2 2.4-0.4 1.3-0.4 2.7z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m153.2 573.1c0 4.9-12.2 8.9-27.3 8.9-15 0-27.3-4-27.3-8.9 0-5 12.3-9 27.3-9 15.1 0 27.3 4 27.3 9z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m220.9 573.1c0 1.8-4.8 3.2-10.7 3.2-5.9 0-10.7-1.4-10.7-3.2 0-1.8 4.8-3.3 10.7-3.3 5.9 0 10.7 1.5 10.7 3.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m360.3 557.3c0 3.8-13.9 6.8-31.1 6.8-17.2 0-31.1-3-31.1-6.8 0-3.8 13.9-6.8 31.1-6.8 17.2 0 31.1 3 31.1 6.8z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m631.4 631.5c-22.8 0-41.4 2.2-41.5 4.9l3.8-80.3c0.1-2.2 17-4 37.7-4 20.7 0 37.6 1.8 37.7 4l3.8 80.3c-0.1-2.7-18.7-4.9-41.5-4.9z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m673.8 473.2c-0.1 2.8-19.1 5.1-42.4 5.1-23.3 0-42.3-2.3-42.5-5.1-0.1-2.8 18.9-5.1 42.5-5.1 23.6 0 42.6 2.3 42.4 5.1z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m615.8 445.2l-32.5 8.7-3.9-14.2 32.6-8.8z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "m614.4 444.3l-30.3 8.2c-1.2 0.4-1.8 1.7-1.3 2.8l3.4 7c1.4 2.8 4.6 4.3 7.6 3.4l2.1-0.5c1.9-0.5 3.9 0.6 4.4 2.5l6.7 24.8c0.5 2.1 2.8 3.4 4.9 2.8 2.2-0.6 3.4-2.8 2.9-4.9l-6.7-24.8c-0.5-1.9 0.6-3.9 2.5-4.4l2-0.5c3.1-0.9 5.1-3.7 4.9-6.9l-0.6-7.7c-0.1-1.2-1.3-2.1-2.5-1.8z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m614.4 444.3l-30.3 8.2c-1.2 0.4-1.8 1.7-1.3 2.8l2.3 4.6 32.2-8.7-0.4-5.1c-0.1-1.2-1.3-2.1-2.5-1.8z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m582.1 438.9l2.9 10.7c0.1 0.2 0.3 0.3 0.5 0.3 0.3-0.1 0.4-0.3 0.4-0.6l-2.9-10.6z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m584.8 438.2l2.8 10.6c0.1 0.3 0.3 0.4 0.6 0.4 0.2-0.1 0.3-0.3 0.3-0.6l-2.9-10.6z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m587.4 437.5l2.9 10.6c0 0.3 0.3 0.4 0.5 0.4 0.2-0.1 0.4-0.4 0.3-0.6l-2.9-10.6z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m590 436.8l2.9 10.6c0 0.3 0.3 0.4 0.5 0.3 0.3 0 0.4-0.3 0.3-0.5l-2.8-10.6z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m592.6 436.1l2.9 10.6c0.1 0.3 0.3 0.4 0.6 0.3 0.2 0 0.3-0.3 0.3-0.5l-2.9-10.6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m595.3 435.4l2.8 10.6c0.1 0.2 0.3 0.4 0.6 0.3 0.2 0 0.4-0.3 0.3-0.5l-2.9-10.7z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m597.9 434.7l2.9 10.6c0 0.2 0.3 0.4 0.5 0.3 0.2-0.1 0.4-0.3 0.3-0.5l-2.9-10.7z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m600.5 434l2.9 10.6c0.1 0.2 0.3 0.4 0.5 0.3 0.3-0.1 0.4-0.3 0.3-0.5l-2.8-10.7z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m603.1 433.2l2.9 10.7c0.1 0.2 0.3 0.4 0.6 0.3 0.2-0.1 0.3-0.3 0.3-0.5l-2.9-10.7z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m605.8 432.5l2.8 10.7c0.1 0.2 0.3 0.3 0.6 0.3 0.2-0.1 0.4-0.3 0.3-0.6l-2.9-10.6z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m608.4 431.8l2.9 10.7c0 0.2 0.3 0.3 0.5 0.3 0.2-0.1 0.4-0.3 0.3-0.6l-2.9-10.6z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m580.1 442.2c0 0 5 4.8 12.5 0.2 5.3-3.3 8.1-3.6 9-1.8 0.9 1.8 1.6 4.8 3.9 3.9 3.2-1.3-0.6-6.5 2-7.6 2.7-1.1 5.3-2.7 4.5-6l-32.6 8.8z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m656.5 465.8l-3.2-0.6 3.7-17.3c0.7-3.1 3.4-5.4 6.6-5.5l18.2-0.5c3.2-0.1 5.9-2.3 6.5-5.4l1.1-5.1c0.3-1-0.4-2.1-1.5-2.3l-24-5.2 0.7-3.2 24 5.2c2.8 0.6 4.6 3.4 4 6.2l-1.1 5.1c-0.9 4.6-4.9 7.9-9.6 8l-18.2 0.5c-1.7 0-3.1 1.2-3.5 2.9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m646.1 514.9l-3.4-0.7c-1-0.2-1.6-1.2-1.4-2.2l12.6-58.3c0.2-1 1.2-1.6 2.2-1.4l3.3 0.7c1.1 0.2 1.7 1.2 1.5 2.2l-12.6 58.3c-0.2 1-1.2 1.6-2.2 1.4z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "E",
    d: "m685.9 421.6l-46.1-10-2.2 10.4 46.1 10c1.5 0.3 3.2-1.8 3.8-4.7 0.6-2.8-0.1-5.4-1.6-5.7z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m641.4 417.4c-0.6 2.9-2.3 5-3.8 4.6-1.5-0.3-2.2-2.9-1.6-5.7 0.6-2.9 2.3-5 3.8-4.7 1.5 0.4 2.2 2.9 1.6 5.8z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m679.4 420.1l-32.9-7c1.5 0.3 2.2 2.9 1.6 5.8-0.6 2.8-2.4 4.9-3.8 4.6l32.8 7.1c1.5 0.3 3.2-1.8 3.8-4.7 0.7-2.8 0-5.4-1.5-5.8z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m631.4 480.5c-22.8 0-41.4-2.2-41.5-5l3.8 80.3c0.1 2.3 17 4.1 37.7 4.1 20.7 0 37.6-1.8 37.7-4.1l3.8-80.3c-0.1 2.8-18.7 5-41.5 5z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "F",
    d: "m607.2 479.6c-10.4-0.9-17.3-2.4-17.3-4.1l3.8 80.3c0 1.4 6.9 2.7 17.3 3.4z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m631.4 486.7c21.4 0 39.2-1.9 42-4.4l0.4-9.1c-0.1 2.8-19.1 5.1-42.4 5.1-23.3 0-42.3-2.3-42.5-5.1l0.4 9.1c2.9 2.5 20.6 4.4 42.1 4.4z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "G",
    d: "m669.8 540.8c-0.4 0.7-0.8 1.3-1.2 1.7-2.6 2.4-5.2 3.2-8 2.6-18-3.7-35.1-62.2-35.2-62.8-0.2-0.7-1-1-1.7-0.7-0.7 0.3-1.1 1-0.9 1.7 0.7 2.5 17.7 60.4 37 64.4q1.1 0.2 2.2 0.2c2.6 0 5.2-1 7.6-3.1z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m671.9 497l-0.4 7.4c4.6 14.6 8.9 33.1 4.4 37.6-2.3 2.3-4.9 3.1-7.7 2.6-18.4-3.7-42.5-61.7-42.7-62.3-0.3-0.7-1.1-1-1.7-0.7-0.7 0.2-1 1-0.8 1.7 1.1 2.4 24.9 59.9 44.7 63.8q1.1 0.2 2.2 0.2 4.3 0 7.8-3.5c6.7-6.7-1.2-33.2-5.8-46.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderDev);
export default __webpack_public_path__ + "static/media/under_dev.a8f83a49c498466b9e946bfc884f893e.svg";
export { ForwardRef as ReactComponent };